import * as angular from 'angular';
import template from './recentCheckLists.tpl.html';
import controller from './recentCheckLists.controller';

export default angular.module('aps.directive.recentCheckLists', [controller])
  .directive('apsRecentCheckLists', recentCheckListsDirective)
  .name;

function recentCheckListsDirective() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'RecentCheckListsCtrl',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      checkListViewAll: '='
    },
    link: function ($scope: any) {
      $scope.$watch('vm.checkListViewAll', function (viewAll) {
        $scope.vm.viewAllChanged(viewAll);
      });
    }
  };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/checks/recentCheckLists.directive.ts